import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterHpSearchValueObject extends ValueObject {
  #hp

  constructor({hp}) {
    super()
    this.#hp = hp
  }

  static create({hp}) {
    return new FilterHpSearchValueObject({hp: FilterRangeSearchValueObject.create(hp)})
  }

  static createWithDefaultValue({config, hp}) {
    const {DEFAULT_HP_SEARCH} = config.get('searchFilters')

    return new FilterHpSearchValueObject({
      hp: FilterRangeSearchValueObject.create({
        from: hp?.from || DEFAULT_HP_SEARCH.from,
        to: hp?.to || DEFAULT_HP_SEARCH.to
      })
    })
  }

  static createQueryParams({config, hp}) {
    const {DEFAULT_HP_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHpSearchValueObject({
      hp: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.HP].from,
          value: hp?.from || DEFAULT_HP_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.HP].to,
          value: hp?.to || DEFAULT_HP_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#hp.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#hp.from.isEmpty && {...this.#hp.from.queryParam}),
      ...(!this.#hp.to.isEmpty && {...this.#hp.to.queryParam})
    }
  }

  get value() {
    return this.#hp.value
  }

  toJSON() {
    return {
      hp: this.#hp.toJSON()
    }
  }
}
